import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const AntSwitch = styled(Switch)(({ theme, backgroundColor, color }) => ({

    width: 28,
    height: 16,
    padding: 0,
    display: 'flex',

    '&:active': {
        '& .MuiSwitch-thumb': {
            width: 15,
        },
        '& .MuiSwitch-switchBase.Mui-checked': {
            transform: 'translateX(9px)',
        },
    },

    '& .MuiSwitch-switchBase': {
        padding: 2,
        '&.Mui-checked': {
            transform: 'translateX(12px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                opacity: 1,
                backgroundColor: backgroundColor,
            },
        },
        '&:hover': {
            backgroundColor: 'transparent !important',
        },
        '&:focus': {
            backgroundColor: 'transparent !important',
        },
    },

    '& .MuiSwitch-thumb': {
        boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
        width: 12,
        height: 12,
        borderRadius: 6,
        backgroundColor: color,
        transition: theme.transitions.create(['width'], {
            duration: 200,
        }),
    },

    '& .MuiSwitch-track': {
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: backgroundColor,
        boxSizing: 'border-box',
    },
}));

export default AntSwitch;